var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share Course"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    clipPath: "url(#clip0_2400_2606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3309 17.3208H29.1567V14.1408C28.8417 14.0975 27.7584 14 26.4967 14C23.8642 14 22.0609 15.6558 22.0609 18.6992V21.5H19.1559V25.055H22.0609V34H25.6225V25.0558H28.41L28.8525 21.5008H25.6217V19.0517C25.6226 18.0242 25.8992 17.3208 27.3309 17.3208Z",
    fill: "#4E5566"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_2606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/FacebookLogo.3701400de335e6553bd1a447c2e60d61.svg";
export { ForwardRef as ReactComponent };